import { Component, EventEmitter, Input, Output, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AddPopupComponent } from '../add-popup/add-popup.component';
import { faXmark, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
@Component({
  selector: 'app-user-kps-table',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AddPopupComponent, FontAwesomeModule],
  templateUrl: './user-kps-table.component.html',
  styleUrl: './user-kps-table.component.css',
})
export class UserKpsTableComponent implements OnInit, OnChanges {
  faXmark = faXmark;
  faTrashCan = faTrashCan;
  showModal = false;
  isEditMode = false
  showDeleteModal = false;;
  editIndex: number | null = null;
  selectedKpsId: number | null = null;
  showSkeleton = true;
  @Input() userKps: any[] = [];
  @Input() loading = false;
  @Output() addKps = new EventEmitter<any>();
  @Output() editKps = new EventEmitter<{ id: any, data: any }>();
  @Output() deleteKps = new EventEmitter<any>();
  @Input() office_roles_array: any[] = [];

  kpsForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.kpsForm = this.fb.group({
      title: ['', Validators.required],
      value: [
        '',
        [Validators.required, Validators.min(0), Validators.max(100)]
      ],
      type: ['', Validators.required],
    });

  }
  ngOnChanges() {
    if (this.loading) {
      this.showTableLoader();
    }
  }
  ngOnInit(): void {
    this.showTableLoader();
    
  }
skeletonRows: any[] = [];
skeletonCols: any[] = [];

showTableLoader(duration = 800) {
  this.showSkeleton = true;

  const rowCount = this.userKps?.length || 5;
  const columnCount = 4; // 👈 match your table columns

  this.skeletonRows = Array(rowCount).fill(0);
  this.skeletonCols = Array(columnCount).fill(0);

  setTimeout(() => {
    this.showSkeleton = false;
  }, duration);
}

  toggleModal() {
    this.showModal = !this.showModal;

    if (!this.showModal) {
      this.isEditMode = false;
      this.editIndex = null;
      this.selectedKpsId = null;
      this.kpsForm.reset();
    }
  }

  openEditModal(item: any, index: number) {
    this.isEditMode = true;
    this.editIndex = index;
    this.selectedKpsId = item?.id ?? null;
    this.showModal = true;

    this.kpsForm.patchValue({
      title: item.title,
      value: typeof item.value === 'string' ? item.value.replace('%', '') : item.value,
      type: item.type,
    });
  }


  onSave() {
    if (this.kpsForm.invalid) return;

    const formValue = this.kpsForm.value;
    const dataForService = {
      kps_name: formValue.title,
      kps_value: formValue.value,
      employee_role: formValue.type
    };

    if (this.isEditMode && this.editIndex !== null) {
      if (this.selectedKpsId !== null) {
        this.editKps.emit({ id: this.selectedKpsId, data: dataForService });
      }
    } else {
      this.addKps.emit(dataForService);
    }

    this.toggleModal();
  }

  openDeleteModal(id: any) {
    this.selectedKpsId = id;
    this.showDeleteModal = true;
  }

  confirmDelete() {
    if (this.selectedKpsId != null) {
      this.deleteKps.emit(this.selectedKpsId);
    }
    this.closeDeleteModal();
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
    this.selectedKpsId = null;
  }

 
}
